// extracted by mini-css-extract-plugin
export default {"container":"_45c4408a","textContainer":"_8ce48477","readMore":"_eb1f65aa"};